import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useMessage } from '../../../../hooks'
import { clientReviewService } from '../../services'
import { appName } from '../../appConfig'

// Kontakter tab's read-only rollup of everyone flagged as a recruitment
// candidate across the client's reviews (ClientReviewEdit.js's Rekrytering
// tab). Reviews come back oldest-first (see ReviewTrendSection.js), so a
// later occurrence of the same person overwrites an earlier one — the list
// always shows each person's most recent role/next step/period.
export const RecruitmentCandidates = ({ clientSlug }) => {
  const { showMessage } = useMessage()

  const [candidates, setCandidates] = useState([])
  const [loading, setLoading]       = useState(true)

  useEffect(() => {
    const ctrl = new AbortController()
    clientReviewService.getByClient(clientSlug, ctrl.signal)
      .then(res => {
        const byPerson = new Map()
        ;(res.clientReviews || []).forEach(r => {
          const list = r.client_review_data?.recruitment_candidates || []
          list.forEach(c => {
            const key = c.person_uuid || c.person_name || c.name
            if (!key) return
            byPerson.set(key, {
              person_uuid:  c.person_uuid,
              person_name:  c.person_name || c.name,
              role:         c.role,
              next_step:    c.next_step,
              period:       r.client_review_period,
              reviewSlug:   r.client_review_slug,
            })
          })
        })
        setCandidates(Array.from(byPerson.values()))
        setLoading(false)
      })
      .catch(err => {
        if (err.name !== 'AbortError') { showMessage('Kunde inte ladda rekryteringskandidater', 'error'); setLoading(false) }
      })
    return () => ctrl.abort()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientSlug])

  if (loading) return <p style={{ color: 'var(--color-dark-grey)' }}>Laddar…</p>

  if (candidates.length === 0) {
    return <p style={{ color: 'var(--color-dark-grey)', fontStyle: 'italic' }}>Inga rekryteringskandidater ännu.</p>
  }

  return (
    <table className="cc-table">
      <thead><tr><th>Namn</th><th>Roll</th><th>Nästa steg</th><th>Senast nämnd</th></tr></thead>
      <tbody>
        {candidates.map((c, i) => (
          <tr key={c.person_uuid || c.person_name || i}>
            <td>{c.person_uuid ? <Link className="link" to={`/network/persons/${c.person_uuid}`}>{c.person_name}</Link> : c.person_name}</td>
            <td style={{ color: 'var(--color-dark-grey)' }}>{c.role || '—'}</td>
            <td style={{ color: 'var(--color-dark-grey)' }}>{c.next_step || '—'}</td>
            <td><Link className="link" to={`/${appName}/${clientSlug}/reviews/${c.reviewSlug}/edit`}>{c.period}</Link></td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
